import Splide from "@splidejs/splide";
import {makeSlug, scrollToElem} from "./tools";

export default class HeadingNavBar {
    manageHeadingNavBar__loaded = false;

    constructor() {
        // if (document.readyState === 'loading') {
        //     window.addEventListener('DOMContentLoaded', () => {
        //         console.log('drugie');
        //         this.manageHeadingNavBar();
        //     })
        // } else {
        //     console.log('pierwsze');
        //     this.manageHeadingNavBar(true);
        // }
    }

    modifyUlClassOnResize(wrapper) {
        let widthEls = 0;
        wrapper.querySelectorAll('li').forEach(el => widthEls += el.clientWidth);

        if (widthEls < (window.innerWidth * .9)) {
            wrapper.classList.add('justify-content-center');
        } else {
            wrapper.classList.contains('justify-content-center') && wrapper.classList.remove('justify-content-center');
        }
    }

    startSplideCarousel(ulList) {
        const splide = new Splide('#glide-hnb', {
            type: 'slide', // height: '50px',
            arrows: false, pagination: false, gap: '0px', drag: 'free', snap: true, autoWidth: true, breakpoints: {
                640: {gap: '0px'}, 910: {gap: '5px'},
            }

        });

        splide.mount();

        this.modifyUlClassOnResize(ulList);

        window.addEventListener('resize', () => {
            this.modifyUlClassOnResize(ulList);
        });
    }

    mode_action_h2List(headingNavBar) {

        if (headingNavBar && document.querySelector('h2')) {
            const wrapperDiv = document.createElement('div');
            const wrapper = document.createElement('div');
            const ulList = document.createElement('ul');

            //weryfikacja dubli
            let h2Ids = [];
            document.querySelectorAll('.site-main h2').forEach(heading => {
                const title = heading.dataset.shortTitle ? heading.dataset.shortTitle : heading.innerText;
                if ('' !== title) {

                    if (!heading.hasAttribute('id') || (heading.hasAttribute('id') && h2Ids.indexOf(heading.getAttribute('id')))) {
                        let a = 'heading-' + h2Ids.length;
                        heading.setAttribute('id', a);
                        h2Ids.push(a);
                    } else {
                        h2Ids.push(heading.getAttribute('id'));
                    }

                    let anchorUrl = heading.hasAttribute('id') ? heading.getAttribute('id') : null;
                    if (!anchorUrl) {
                        anchorUrl = makeSlug(heading.innerText);
                        heading.setAttribute('id', anchorUrl);
                    }
                    const itemList = document.createElement('li');
                    itemList.innerHTML = '<a href="#' + anchorUrl + '">' + title + '</a>';
                    itemList.classList.add('splide__slide');
                    ulList.appendChild(itemList);
                }
            });
            const scrollTopBtn = document.createElement('li');
            scrollTopBtn.className = 'splide__slide';
            scrollTopBtn.innerHTML = '<a class="link-scrolltop" href="#page">Scroll to the top</a>';
            ulList.appendChild(scrollTopBtn);

            if (ulList.children.length > 1) {

                wrapper.classList.add('splide__track');
                ulList.classList.add('splide__list');
                wrapperDiv.classList.add('splide');
                wrapperDiv.setAttribute('id', 'glide-hnb');
                wrapper.appendChild(ulList);
                wrapperDiv.appendChild(wrapper);
                headingNavBar.appendChild(wrapperDiv);

                ulList.querySelectorAll('a').forEach(link => link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const id = e.target.getAttribute('href').slice(1);

                    if (!document.getElementById(id)) {
                        return false;
                    }

                    scrollToElem(id);

                }))

            }

            headingNavBar.setAttribute('initialized', true);

            const event__customHeadingIds = new CustomEvent("customHeadingIdsComplete", {detail: h2Ids});
            document.dispatchEvent(event__customHeadingIds);

            window.addEventListener('scroll', () => {
                const elementRect = headingNavBar.getBoundingClientRect();
                const isAtTop = elementRect.top <= 0;

                if (isAtTop) {
                    headingNavBar.classList.add('show-fixed');
                } else {
                    headingNavBar.classList.contains('show-fixed') && headingNavBar.classList.remove('show-fixed');
                }
            });


            const allH2 = document.querySelectorAll('h2');
            const menuLinks = document.querySelectorAll('#heading-menu-wrapper ul li a');

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        menuLinks.forEach(link => {
                            link.classList.toggle('active', link.getAttribute('href') === '#' + entry.target.id);
                        });
                    }
                });
            }, {
                rootMargin: '0px 0px -60% 0px', // Adjust as needed
                threshold: .5
            });

            allH2.forEach(section => {
                observer.observe(section);
            });

            this.startSplideCarousel(ulList);
        }
    }

    mode_action_news_cat(headingNavBar) {
        fetch('/wp-json/wp/v2/categories?per_page=100&_fields=id,name&parent=323')
            .then(response => response.json())
            .then(data => {
                const wrapperDiv = document.createElement('div');
                const wrapper = document.createElement('div');
                const ulList = document.createElement('ul');


                const shortList = {}
                const queryParams = window.location.search && Array.from(new URLSearchParams(window.location.search).entries()).filter(x => x[0] === 'curCatSelected');
                const itemList = document.createElement('li');
                const aTag = document.createElement('a');
                aTag.dataset.cat = '323';
                // aTag.dataset.slug = 'all';
                aTag.setAttribute('href', '#');
                aTag.innerHTML = 'All';
                if (!queryParams || queryParams.length === 0) {
                    aTag.classList.add('selected');
                }
                aTag.classList.add('all');
                itemList.appendChild(aTag);
                itemList.classList.add('splide__slide');
                ulList.appendChild(itemList);
                wrapperDiv.appendChild(ulList);
                shortList['all'] = true;

                // urlCatInfo =
                data.forEach(obj => {

                    const itemList = document.createElement('li');
                    const aTag = document.createElement('a');
                    aTag.dataset.cat = obj.id;
                    aTag.setAttribute('href', '#');
                    if (queryParams && queryParams.length) {
                        let qp = queryParams[0];
                        if (parseInt(qp[1]) === parseInt(obj.id)) {
                            aTag.classList.add('selected');
                        }
                    }
                    aTag.innerText = obj.name;
                    itemList.appendChild(aTag);
                    itemList.classList.add('splide__slide');
                    ulList.appendChild(itemList);
                    wrapperDiv.appendChild(ulList);
                });
                // headingNavBar.innerHTML = wrapperDiv.outerHTML;
                wrapper.classList.add('splide__track');
                ulList.classList.add('splide__list');
                wrapperDiv.classList.add('splide');
                wrapperDiv.setAttribute('id', 'glide-hnb');
                wrapper.appendChild(ulList);
                wrapperDiv.appendChild(wrapper);
                headingNavBar.appendChild(wrapperDiv);

                this.startSplideCarousel(ulList);


                if (queryParams.length) {
                    const pValue = queryParams.filter(x => x[0] === 'curCatSelected')[0][1];
                    if (pValue && document.querySelector('#heading-menu-wrapper a[data-cat="' + pValue + '"]')) {
                        document.querySelector('#heading-menu-wrapper a[data-cat="' + pValue + '"]').dispatchEvent(new Event('click'));

                    }
                }
            });
    }

    mode_action_search_cat(headingNavBar) {
        const wrapperDiv = document.createElement('div');
        const wrapper = document.createElement('div');
        const ulList = document.createElement('ul');

        const shortList = {}

        let urlParams = [];
        const searchParams = new URLSearchParams(window.location.search) ?? null;
        if (searchParams.has('t')) {
            urlParams = searchParams.get('t').split(',');
        }

        if (document.querySelector('form.search-form')) {
            const inp = document.createElement('input');
            inp.setAttribute('type', 'hidden');
            inp.setAttribute('name', 't');

            document.querySelector('form.search-form').appendChild(inp);
        }

        const itemList = document.createElement('li');
        const aTag = document.createElement('a');
        aTag.dataset.cat = '*';
        aTag.dataset.slug = 'all';
        aTag.setAttribute('href', '#');
        aTag.innerHTML = 'All';
        if (!urlParams.length) {
            aTag.classList.add('selected');
        }
        itemList.appendChild(aTag);
        itemList.classList.add('splide__slide');
        ulList.appendChild(itemList);
        wrapperDiv.appendChild(ulList);
        aTag.addEventListener('click', () => {
            document.querySelector('form.search-form input[name="t"]').remove();
            document.querySelector('form.search-form').submit();
        });

        shortList['all'] = true;

        const data = [{
            id: '', slug: 'featured_products', name: 'Featured products'
        }, {id: '', slug: 'product_promotions', name: 'Product promotions'}, {
            id: '', slug: 'edu_center', name: 'Education center'
        }, {id: '', slug: 'events', name: 'Events'},];
        data.forEach(obj => {

            const itemList = document.createElement('li');
            const aTag = document.createElement('a');
            aTag.dataset.cat = obj.slug
            aTag.setAttribute('href', '#');
            aTag.innerText = obj.name;
            if (urlParams.indexOf(obj.slug) > -1) {
                aTag.classList.add('selected');
            }

            aTag.addEventListener('click', (e) => {
                e.target.closest('ul').querySelector('.selected') && e.target.closest('ul').querySelector('.selected').classList.remove('selected');
                e.target.classList.toggle('selected');
                document.querySelector('form.search-form input[name="t"]').value = (Array.from(headingNavBar.querySelectorAll('a.selected')).map(x => x.dataset.cat)).join(',');
                document.querySelector('form.search-form').submit();
            });
            itemList.appendChild(aTag);
            itemList.classList.add('splide__slide');
            ulList.appendChild(itemList);
            wrapperDiv.appendChild(ulList);
        });
        // headingNavBar.innerHTML = wrapperDiv.outerHTML;
        wrapper.classList.add('splide__track');
        ulList.classList.add('splide__list');
        wrapperDiv.classList.add('splide');
        wrapperDiv.setAttribute('id', 'glide-hnb');
        wrapper.appendChild(ulList);
        wrapperDiv.appendChild(wrapper);
        headingNavBar.appendChild(wrapperDiv);

        this.startSplideCarousel(ulList);
    }

    mode_action_calendar_cat(headingNavBar) {
        fetch('/wp-json/wp/v2/calendar_category?per_page=100')
            .then(response => response.json())
            .then(data => {
                const wrapperDiv = document.createElement('div');
                const wrapper = document.createElement('div');
                const ulList = document.createElement('ul');

                const shortList = {}

                const itemList = document.createElement('li');
                const aTag = document.createElement('a');
                aTag.dataset.cat = '*';
                aTag.dataset.slug = 'all';
                aTag.setAttribute('href', '#');
                aTag.innerHTML = 'All';
                aTag.classList.add('selected');
                itemList.appendChild(aTag);
                itemList.classList.add('splide__slide');
                ulList.appendChild(itemList);
                wrapperDiv.appendChild(ulList);
                shortList['all'] = true;

                data.forEach(obj => {

                    const itemList = document.createElement('li');
                    const aTag = document.createElement('a');
                    aTag.dataset.cat = obj.id;
                    aTag.dataset.slug = obj.slug;
                    aTag.setAttribute('href', '#');
                    aTag.innerHTML = '<span class="rect" style="background:' + obj.acf.main_color + '"></span>' + obj.name;
                    shortList[obj.slug] = false;
                    itemList.appendChild(aTag);
                    itemList.classList.add('splide__slide');
                    ulList.appendChild(itemList);
                    wrapperDiv.appendChild(ulList);
                });
                if (this.externalClass && typeof this.externalClass === 'object') {
                    this.externalClass.updateFiltersCategories(shortList);
                }

                if (ulList.children.length > 1) {

                    wrapper.classList.add('splide__track');
                    ulList.classList.add('splide__list');
                    wrapperDiv.classList.add('splide');
                    wrapperDiv.setAttribute('id', 'glide-hnb');
                    wrapper.appendChild(ulList);
                    wrapperDiv.appendChild(wrapper);
                    headingNavBar.appendChild(wrapperDiv);

                    ulList.querySelectorAll('a').forEach(link => link.addEventListener('click', (e) => {
                        e.preventDefault();
                        const slug = e.currentTarget.dataset.slug;
                        const isSelected = e.currentTarget.classList.contains('selected');
                        if ('all' === slug && isSelected) {
                            return false;
                        }

                        if (this.externalClass) {
                            e.currentTarget.closest('ul').querySelector('.selected') && e.currentTarget.closest('ul').querySelector('.selected').classList.remove('selected');
                            let newStatus = undefined;
                            if (this.externalClass && typeof this.externalClass === 'object') {
                                const newStatus = this.externalClass.toggleCategoriesFilter(slug);
                                if (newStatus) {
                                    e.currentTarget.classList.add('selected');
                                }
                            }

                            if ('all' !== slug && e.currentTarget.closest('ul').querySelector('a[data-slug="all"].selected')) {
                                e.currentTarget.closest('ul').querySelector('a[data-slug="all"].selected').classList.remove('selected');
                            }
                            if ('all' === slug && newStatus) {
                                e.currentTarget.closest('ul').querySelectorAll('a').forEach(link => 'all' !== link.dataset.slug && link.classList.contains('selected') && link.classList.remove('selected'))
                            }

                        }
                    }))

                    this.startSplideCarousel(ulList);
                }
            });
    }

    mode_action_letters(headingNavBar) {

        if (headingNavBar && headingNavBar.nextElementSibling) {
            const wrapperDiv = document.createElement('div');
            const wrapper = document.createElement('div');
            const ulList = document.createElement('ul');

            let lettersFulArray = [];

            if (!headingNavBar.nextElementSibling.querySelectorAll('li .title').length) {
                setTimeout(() => {
                    this.mode_action_letters(headingNavBar);
                }, 1000);

            } else {

                headingNavBar.nextElementSibling.querySelectorAll('li .title').forEach(titleElem => {
                    const title = titleElem.innerText;
                    if ('' !== title) {
                        lettersFulArray.push(title.substring(0, 1).toUpperCase());
                    }
                });

                let lettersUniqueArray = lettersFulArray.filter(function (v, i, self) {
                    return i === self.indexOf(v);
                });

                (lettersUniqueArray.sort()).forEach(title => {
                    const itemList = document.createElement('li');
                    const aTag = document.createElement('a');
                    aTag.dataset.fletter = title.toLowerCase();
                    aTag.setAttribute('href', '#');
                    aTag.innerText = title;
                    itemList.appendChild(aTag);
                    itemList.classList.add('splide__slide');
                    ulList.appendChild(itemList);
                });


                const scrollTopBtn = document.createElement('li');
                scrollTopBtn.className = 'splide__slide';
                scrollTopBtn.innerHTML = '<a data-fletter="*" class="link-scrolltop" href="#">Show all</a>';
                ulList.appendChild(scrollTopBtn);

                if (ulList.children.length > 1) {

                    wrapper.classList.add('splide__track');
                    ulList.classList.add('splide__list');
                    wrapperDiv.classList.add('splide');
                    wrapperDiv.setAttribute('id', 'glide-hnb');
                    wrapper.appendChild(ulList);
                    wrapperDiv.appendChild(wrapper);
                    headingNavBar.innerHTML = wrapperDiv.outerHTML;

                    headingNavBar.querySelectorAll('a').forEach(aTag => aTag.addEventListener('click', e => {
                        e.preventDefault();
                        const letter = e.target.dataset.fletter;
                        const targetList = e.target.closest('#heading-menu-wrapper').nextElementSibling.querySelector('ul');

                        headingNavBar.querySelector('a.active') && headingNavBar.querySelector('a.active').classList.remove('active');

                        if (letter === '*') {
                            targetList.querySelectorAll('li').forEach(el => el.style.opacity = 1);
                            scrollToElem('heading-menu-wrapper');
                        } else {
                            e.target.classList.add('active');
                            targetList.querySelectorAll('li:not([data-fletter="' + letter + '"])').forEach(el => el.style.opacity = .18);
                            targetList.querySelectorAll('li[data-fletter="' + letter + '"]').forEach(el => el.style.opacity = 1);
                            scrollToElem('letter_' + letter);
                        }

                    }))

                    this.startSplideCarousel(ulList);
                }

                headingNavBar.setAttribute('initialized', true);

                window.addEventListener('scroll', () => {
                    const elementRect = headingNavBar.getBoundingClientRect();
                    const isAtTop = elementRect.top <= 0;

                    if (isAtTop) {
                        headingNavBar.classList.add('show-fixed');
                    } else {
                        headingNavBar.classList.contains('show-fixed') && headingNavBar.classList.remove('show-fixed');
                    }
                });

            }
        }
    }

    manageHeadingNavBar(outerClass = false) {
        if (this.manageHeadingNavBar__loaded) {
            return false;
        }
        this.externalClass = outerClass;

        const headingNavBar = document.getElementById('heading-menu-wrapper');
        if (!headingNavBar) {
            return false;
        }

        if (headingNavBar.getAttribute('initialized')) {
            return false;
        }
        if (headingNavBar.dataset.kind === 'letters') {
            this.mode_action_letters(headingNavBar);
        } else if (headingNavBar.dataset.kind === 'category') {
            this.mode_action_news_cat(headingNavBar);
        } else if (headingNavBar.dataset.kind === 'calendar_category' && this.externalClass) {
            this.mode_action_calendar_cat(headingNavBar);
        } else if (headingNavBar.dataset.kind === 'search_category') {
            this.mode_action_search_cat(headingNavBar);
        } else {
            this.mode_action_h2List(headingNavBar);
        }

    }

}
